import {request,newVue,requestMsg} from "./request";
export {newVue}

export function getGuideImgList(pageNum,pageSize) {
  return request({
    url: '/guideImg/getGuideImgList',
    params: {
      pageNum: pageNum,
      pageSize: pageSize
    }
  })
}

export function delByGuideImgId(id) {
  return requestMsg({
    url: '/guideImg/delByGuideImgId',
    params: {
      id:id
    }
  })
}

export function getGuideImgById(id) {
  return request({
    url: '/guideImg/getGuideImgById',
    params: {
      id:id
    }
  })
}

export function updateGuideImg(merchants) {
  return requestMsg({
    url: '/guideImg/updateGuideImg',
    data: JSON.stringify(merchants),
    method: "POST",
    headers : {"Content-Type" : "application/json;charset=utf-8"},
  })
}
